import backend from "../../utils/backend";
import * as actionTypes from "../../constants/actionTypes";

import { changeStep, toggleAuthDrawer } from "actions/authDrawer";
import { SIGNIN } from "constants/authDrawer";

export const typingUserSettings = (obj) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.TYPING_USER_SETTINGS,
      payload: obj,
    });
  };
};

export const submitUserSettings = (obj) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBMIT_USER_SETTINGS,
    });

    // Omit subscriptions and saved_stories from request otherwise backend will think we are trying to change subscriptions and saved_stories
    const { subscriptions, saved_stories, ...data } = obj; // eslint-disable-line no-unused-vars

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data,
    })
      .then(() => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SETTINGS_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SETTINGS_ERROR,
          payload: err,
        });
      });
  };
};

export const getSubscriptions = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_USER_SUBSCRIPTIONS,
    });

    return backend.request({
      method: "GET",
      url: "/subscriptions/",
    })
      .then((response) => {
        dispatch({
          type: actionTypes.GET_USER_SUBSCRIPTIONS_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_USER_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};

export const toggleCheckbox = (subscriptions, name, checked) => {
  return (dispatch) => {
    let newSubscriptions = subscriptions;

    if (checked) {
      newSubscriptions = newSubscriptions.concat(name);
    } else {
      newSubscriptions = newSubscriptions.filter((subscription) => {
        return subscription !== name;
      });
    }

    dispatch({
      type: actionTypes.CHANGE_USER_SUBSCRIPTIONS,
      payload: newSubscriptions,
    });
  };
};

export const submitSubscriptions = (subscriptionIds) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS,
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptionIds,
      },
    })
      .then(() => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};

export const submitSavedStories = (savedStoryIds) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SUBMIT_USER_SAVED_STORIES,
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        saved_stories: savedStoryIds,
      },
    })
      .then(() => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SAVED_STORIES_SUCCESS,
          payload: savedStoryIds,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.SUBMIT_USER_SAVED_STORIES_ERROR,
          payload: err,
        });
      });
  };
};

export const saveStory = (storyId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SAVE_STORY,
    });

    return backend.request({
      method: "POST",
      url: `readers/save/${storyId}/`,
    })
      .then(() => {
        dispatch({
          type: actionTypes.SAVE_STORY_SUCCESS,
          payload: storyId,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.SAVE_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const unsaveStory = (storyId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UNSAVE_STORY,
    });

    return backend.request({
      method: "DELETE",
      url: `readers/unsave/${storyId}/`,
    })
      .then(() => {
        dispatch({
          type: actionTypes.UNSAVE_STORY_SUCCESS,
          payload: storyId,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.UNSAVE_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const toggleStorySave = (storyId, saved) => {
  return (dispatch, getState) => {
    const loggedIn = getState().authDrawer.loggedIn;
    if (loggedIn) {
      if (saved) {
        return dispatch(unsaveStory(storyId));
      } else {
        return dispatch(saveStory(storyId));
      }
    } else {
      dispatch(changeStep(SIGNIN));
      dispatch(toggleAuthDrawer(true));
    }
  };
};

export const deleteAccount = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_ACCOUNT,
    });

    return backend.request({
      method: "DELETE",
      url: "/readers/delete/",
    })
      .then(() => {
        dispatch({
          type: actionTypes.DELETE_ACCOUNT_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.DELETE_ACCOUNT_ERROR,
          payload: err,
        });
      });
  };
};

export const changePassword = (passwords) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_PASSWORD,
    });

    return backend.request({
      method: "POST",
      url: "/readers/update-password/",
      data: {
        password: passwords.password,
        password1: passwords.password1,
        password2: passwords.password2,
      },
    })
      .then(() => {
        dispatch({
          type: actionTypes.CHANGE_PASSWORD_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.CHANGE_PASSWORD_ERROR,
          payload: err,
        });
      });
  };
};
